<template>
    <rkm-overlay>
        <rkm-layout-body title="Cadastrar destino">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from '@/components/transporte-paciente/destino/Form'

// Vuex.
import { mapActions } from 'vuex';

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        handleExit() {
            this.$router.push({ name: 'transporte-paciente-destino-list' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>